



































































































































import { Component, Prop } from 'vue-property-decorator';
import {
    DxDataGrid,
    DxColumn,
    DxEditing,
    DxPopup,
    DxForm,
    DxLookup
} from 'devextreme-vue/data-grid';
import { DxItem } from 'devextreme-vue/form';
import DataSource from 'devextreme/data/data_source';
import {
    Table,
    TableConfig,
    defaultTableConfig,
    removeItemsFromView,
    columnTemplates
} from '@/core/components/table';
import {
    CONTRACTS,
    WindowsServiceContract,
    FetchServiceContract
} from '@/core/contracts';
import { Inject } from '@/core/helpers/vue-inversify-decorator';
import { Channel, Site } from '@/dto';
import { ContextsState } from '@/store';
import { localize } from '@/core/filters';
import DevExpress from 'devextreme/bundles/dx.all';
import { DxRequiredRule, DxCustomRule } from 'devextreme-vue/validator';
import Validators from '@/core/helpers/validators';
import { getParentId } from '@/core/components/tree/treeHelpers';
import { ResourceTypeTree } from '@/dto';

@Component({
    components: {
        DxDataGrid,
        DxColumn,
        DxEditing,
        DxPopup,
        DxForm,
        DxItem,
        DxRequiredRule,
        DxCustomRule,
        DxLookup
    }
})
export default class ChannelsListTable extends Validators {
    @Prop({ type: String, required: true }) public tableKey!: string;
    @Prop({ type: Object, required: true }) public dataSource!: DataSource;
    @Prop({ type: Array, required: true }) public sites!: Site[];
    @Prop({ type: Array, required: true }) public resourceTypes!: any[];

    @Inject(CONTRACTS.WindowsService)
    private _windowsService?: WindowsServiceContract;
    @Inject(CONTRACTS.FetchService)
    private _fetchService?: FetchServiceContract;

    public get tableConfig(): Partial<TableConfig> {
        return {
            ...defaultTableConfig(this)
        };
    }

    public async mounted() {
        // raise instance of the table up to parent
        this.$emit('setTableInstance', this.tableInstance);
    }

    public get tableInstance(): Table {
        const element = this.$refs['data-grid'] as unknown;
        return (element as DxDataGrid).instance!;
    }

    public get columnTemplates() {
        return columnTemplates;
    }

    public get localize() {
        return localize;
    }

    public getDataGridInstance(): Table {
        const element = this.$refs['data-grid'] as unknown;
        return (element as DxDataGrid).instance!;
    }

    public deleteChannel() {
        this._windowsService!.showDialog(
            localize('ChannelSimpleDeleteMessage'),
            [
                { id: 1, caption: localize('DialogYes') },
                { id: 2, caption: localize('DialogCancel') }
            ]
        ).then(id => {
            if (id === 1) {
                const channel = this.tableInstance.getSelectedRowsData()[0];
                const data = {
                    Channels_Partial: [
                        {
                            id: channel.id,
                            IsDeleted: true
                        }
                    ]
                };
                const currentContextId = ContextsState.currentContextId;
                const url = `/files/contexts/${currentContextId}?ignoreWarnings=true`;
                this._fetchService!.post<Channel>(
                    url,
                    JSON.stringify(data)
                ).then(() => this.getDataGridInstance().refresh());
            }
        });
    }

    private get localizePlaceholder() {
        return localize('PlaceholderAny');
    }

    private getloadHandler(): (parameters: any) => Promise<any[]> {
        return (parameters: any) => {
            return this.load(parameters);
        };
    }

    private async load(parameters: any) {
        const currentContextId = ContextsState.currentContextId;
        const parentId = parameters && parameters.filter ? getParentId(parameters.filter) : '';
        const url = `/contexts/${currentContextId}/resourceTypesList/${parentId}`;
        return await this._fetchService!.get<ResourceTypeTree[]>(url);
    }

    private getloadSelectedItemsHandler(): (items: any) => Promise<any[]> {
        return (items: any) => {
            return this.loadSelectedItems(items);
        };
    }

    private async loadSelectedItems(items: any) {
        const currentContextId = ContextsState.currentContextId;
        const url = `/contexts/${currentContextId}/resourceTypesList/selected/${items}`;
        const data = await this._fetchService!.get<ResourceTypeTree[]>(url);

        return data;
    }
}
